{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Indtast venligst din e-mail.",
      "ERROR": "Indtast venligst en gyldig e-mail."
    },
    "API": {
      "SUCCESS_MESSAGE": "Link til nulstilling af adgangskode er blevet sendt til din e-mail.",
      "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
    },
    "SUBMIT": "Send"
  }
}
